import React, { Component } from "react";
import { Table, Glyphicon, FormGroup, ControlLabel } from 'react-bootstrap';
import { toInt, getTimeInIST, format_without_time, format, format_display_DDMMYYYY, format_fancy, convertDistance, format_fancy_notime, formatNumber, HtmlTooltip, openMap, handleApproveDeliveryChange } from '../Utils'
import moment from 'moment';
import '../css/storedelivery.css';
import { DeliveryService } from "../Services/DeliveryService";
import { Constants } from "../Constants";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Typeahead } from 'react-bootstrap-typeahead';
import { UserService } from "../Services/UserService";
import { ProductService } from "../Services/ProductService";
import { NotificationService } from '../Services/NotificationService';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles, Chip, Tooltip, ListItemText, LinearProgress, Icon, Hidden } from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { RowCountOptions } from "../Config";
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import FormControl from '@material-ui/core/FormControl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import clsx from "clsx";
import { ROLES } from "../Roles";
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import { Autocomplete, Skeleton } from '@material-ui/lab';
import DateRangeIcon from '@material-ui/icons/DateRange';
import TodayIcon from '@material-ui/icons/Today';
import { Color } from '../Constants';
import MarkCustomerDelivery from "../components/MarkCustomerDelivery";

const styles = theme => ({
    card: {
        minWidth: 300,
    },
    fab: {
        margin: theme.spacing(1),
    },
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "100%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom: '20px',
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
    formControlLeft: {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(4),
        },
    },
    selectRoot: {
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
    autoCompleteSelection: {
        minWidth: 450,
        [theme.breakpoints.down('md')]: {
            minWidth: 300
        }
    },
    speedDial: {
        margin: theme.spacing(1),
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        position: 'fixed',
        zIndex: 2,
        '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
            bottom: theme.spacing(2),
            right: theme.spacing(2),
        },
        '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
            top: theme.spacing(2),
            left: theme.spacing(2),
        },
    },
    tooltiptitle: {
        maxWidth: 'none',
        fontSize: 16
    }
});

class ViewCustomerSchedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showNewDelivery: false,
            data: [],
            customerDeliveryMap: new Map(),
            customerMap: new Map(),
            current_rows: [],
            modal: { customer: {}, deliveries: [] },
            highlightDates: [],
            new_delivery: { schedule_date: moment().startOf('day'), products: new Map(), returns: new Map(), delivery_date: undefined },
            customerList: [],
            selectedCustomerBasic: {},
            customer: {},
            product_rows: [],
            products: [],
            deliveryProductMap: new Map(),
            editMode: false,
            approvalRequired: false,
            show_approval_option: false,

            numItemsPerPage: 10,
            currentPageNumber: 0,
            totalItems: 0,
            totalPages: 0,
            columns: [
                { id: 'schedule_date', numeric: false, disablePadding: false, label: 'Scheduled Date', sortable: false },
                { id: 'away', numeric: true, disablePadding: false, label: 'Distance from Destination', sortable: false },
                { id: 'issued_qty', numeric: false, disablePadding: false, label: 'Scheduled Qty', sortable: false },
                { id: 'total_amount', numeric: false, disablePadding: false, label: 'Total Amount', sortable: false },
                { id: 'delivered_count', numeric: false, disablePadding: false, label: 'Delivered Count', sortable: false },
                { id: 'bottles_returned', numeric: false, disablePadding: false, label: 'Bottles Returned Count', sortable: false },
                { id: 'delivery_date', numeric: false, disablePadding: false, label: 'Delivery Date', sortable: false },
                { id: 'actions', numeric: false, disablePadding: false, label: '', sortable: false },
            ],

            selected_customer: "-1",
            startDate: moment().subtract(1, "month"),
            endDate: moment().add(7, "days"),
            customer_names: [],
            store_contract: new Map(),
            loading: false,
            dialog_id: undefined,
            dialog_open: false,
            delivery_dialog_user: undefined,
            speedDialOpen: false,
            speedDialDirection: 'up',
            periodic: false,
            skeleton_rows: Array.from(new Array(2)).map((item, index) =>
                <tr key={index}>
                    <td style={{ verticalAlign: "middle" }}><Skeleton animation="wave" variant="rect" width={200} height={100} /></td>
                    <td style={{ verticalAlign: "middle" }}><Skeleton animation="wave" variant="rect" width={300} height={100} /></td>
                    <td style={{ verticalAlign: "middle" }}><Skeleton animation="wave" variant="rect" width={300} height={100} /></td>
                </tr>
            ),
            skeleton_rows_table: Array.from(new Array(6)).map((item, index) =>
                <tr key={index} >
                    <td colSpan={10}>
                        <Skeleton animation="wave" variant="rect" height={30} />
                    </td>
                </tr>
            ),
        }

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.showDetails = this.showDetails.bind(this);
        this.resetNewDelivery = this.resetNewDelivery.bind(this);

        this.handleCloseNew = this.handleCloseNew.bind(this);
        this.handleShowNew = this.handleShowNew.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDeliveryDateChange = this.handleDeliveryDateChange.bind(this);
        this.scheduleNewDelivery = this.scheduleNewDelivery.bind(this);
        this.updateDeliveryDetails = this.updateDeliveryDetails.bind(this);

        this.edit = this.edit.bind(this);
        this.delete = this.delete.bind(this);
        this.resendInvoice = this.resendInvoice.bind(this);
        this.postUpdate = this.postUpdate.bind(this);
    }

    handleOpenSpeedDial = () => {
        this.setState({ speedDialOpen: true });
    }

    handleCloseSpeedDial = () => {
        this.setState({ speedDialOpen: false });
    }

    handleCustomerSelection = (e, selected) => {
        this.setState({ selected_customer: selected.value, selectedCustomerBasic: selected, current_rows: [], show_skeleton_selection: true, new_delivery: { customer_id: selected.value } }, () => {
            UserService.getCustomerDetails(selected.id)
                .then(data => {
                    if (data) {
                        this.setState({ customer: data })
                    }
                })
            this.fetchTotalCount(this.fetchData(0, this.state.numItemsPerPage));
        });
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startDate: date,
        }, () => this.fetchTotalCount(this.fetchData(0, this.state.numItemsPerPage)));
    }

    handleChangeEndDate = (date) => {
        this.setState({
            endDate: date,
        }, () => this.fetchTotalCount(this.fetchData(0, this.state.numItemsPerPage)));
    }

    componentWillMount() {
        this.props.isLoading(true);
        this.fetchStoreNames();
    }

    fetchStoreNames = () => {
        UserService.getCustomerNames()
            .then((data) => {
                console.log(data);
                let customer_names = data.users.map((w) => (
                    {
                        id: w.id,
                        value: w.id,
                        label: `${w.name} (${w.mobile_no})`
                    }
                ));
                this.setState({ customer_names, customerList: data.users });

                this.props.isLoading(false);
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
            });
    }

    fetchTotalCount = (postExecute = undefined) => {
        this.props.showProgressDialog("Fetching...");
        DeliveryService.getTotalDeliveryCountForCustomer(this.state.selected_customer, this.state.startDate, this.state.endDate)
            .then((data) => {
                console.log(data);
                this.setState({
                    totalItems: toInt(data.count),
                    totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
                });
                this.props.isLoading(false);
                if (postExecute) {
                    postExecute();
                } else {
                    this.props.closeProgressDialog();
                }
            })
            .catch(error => {
                console.log(error);
                this.props.isLoading(false);
                this.props.closeProgressDialog();
            });
    }

    componentDidMount() {
        this.fetchProductRows(null, null);
        this.props.setTitle('View Customer Transactions');
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage: event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, false, true));
    }

    handleChangePage = (event, page) => {
        if (this.state.currentPageNumber > page) {
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchRow(newCurrentPage) {
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage, false, true);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    fetchData(start, numberItems, update = false, showLoader = true) {
        let customerDeliveryMap = new Map(), customerMap = new Map(), current_rows = [];
        if (showLoader)
            this.props.isLoading(true);
        DeliveryService.getCustomerDeliveries(this.state.selected_customer, this.state.startDate, this.state.endDate, start, numberItems)
            .then((data) => {
                console.log(data);
                if (data.delivery_schedule && data.delivery_schedule.length > 0) {

                    data.delivery_schedule.forEach(element => {
                        let a = [], b = {};
                        if (customerMap.has(element.transaction_id)) {
                            b = customerMap.get(element.transaction_id);
                            b.product_qty += toInt(element.product_qty);
                            b.revised_delivered_count += toInt(element.revised_delivered_count);
                            b.delivered_count += toInt(element.delivered_count);
                            b.total_amount += toInt(element.delivered_count) > 0 ? parseFloat(element.total_amount) : 0;
                            b.returned_count += toInt(element.returned_count);
                            b.revised_returned_count += toInt(element.revised_returned_count);
                            b.replaced_count += toInt(element.replaced_count);
                            if (!b.delivery_date) {
                                b.delivery_date = element.delivery_date;
                            }
                            if (!b.delivery_agent_id) {
                                b.delivery_agent_id = element.delivery_agent_id;
                            }
                        } else {
                            b.id = element.id;
                            b.transaction_id = element.transaction_id;
                            b.away = element.away;
                            b.expected_delivery_agent_id = element.expected_delivery_agent_id;
                            b.name = element.name;
                            b.mobile_no = element.mobile_no;
                            b.flat = element.flat;
                            b.product_qty = toInt(element.product_qty);
                            b.revised_delivered_count = toInt(element.revised_delivered_count);
                            b.delivered_count = toInt(element.delivered_count);
                            b.total_amount = toInt(element.delivered_count) > 0 ? parseFloat(element.total_amount) : 0;
                            b.returned_count = toInt(element.returned_count);
                            b.revised_returned_count = toInt(element.revised_returned_count);
                            b.replaced_count = toInt(element.replaced_count);
                            b.delivery_date = element.delivery_date;
                            b.schedule_date = element.schedule_date;
                            b.route_id = element.route_id;
                            b.transactions = element.transactions;
                            b.approval_pending = element.approval_pending;
                            b.approver_user_id = element.approver_user_id;
                            b.approver_name = element.approver_name;
                            // b.signature = element.signature;
                            b.reason = element.reason;
                            b.delivery_agent_id = element.delivery_agent_id;
                            b.geo_location = element.geo_location;
                        }
                        customerMap.set(element.transaction_id, b);

                        if (customerDeliveryMap.has(element.transaction_id)) {
                            a = customerDeliveryMap.get(element.transaction_id);
                        }
                        a.push(element);
                        customerDeliveryMap.set(element.transaction_id, a);
                    });
                    customerMap.forEach((value, key, map) => {
                        current_rows.push(
                            <DeliveryDetails 
                                key={key} 
                                user={value} 
                                showDetails={this.showDetails} 
                                markDelivery={this.markDelivery} 
                                edit={this.edit} 
                                delete={this.delete}
                                session_user={this.props.user} />
                        );
                    });
                }
                this.setState({
                    show_skeleton_selection: false,
                    current_rows: current_rows, data: data.delivery_schedule, customerMap: customerMap, customerDeliveryMap: customerDeliveryMap, message: data.delivery_schedule.length > 0 ? "" : "No Data available"
                }, () => {
                    if (update) {
                        this.fetchProductRows(this.state.new_delivery.customer_id, this.state.new_delivery.invoice_no, this.state.new_delivery.transaction_id);
                    }
                });
                if (showLoader)
                    this.props.isLoading(false);
                this.props.closeProgressDialog();
            })
            .catch(error => {
                console.log(error);
                this.props.closeProgressDialog();
                if (showLoader)
                    this.props.isLoading(false);
            });
    }

    fetchProductRows(customer_id, invoice_no = undefined, transaction_id = undefined) {
        this.setState({ product_rows: [] });
        let s = null, nd = null, prodMap = new Map(), returnMap = new Map();
        nd = this.state.new_delivery;
        if (customer_id && transaction_id) {
            s = this.state.customerDeliveryMap.get(transaction_id);
            if (s && s.length > 0 && this.state.new_delivery_orginal) {
                this.setState(prevState => ({ new_delivery_orginal: { ...prevState.new_delivery_orginal, schedules: s } }));
            }
        }

        ProductService.getProductList()
            .then((data) => {
                console.log(data);
                let products = [], pr = [];
                data.products.filter(p => p.status !== -1).forEach((p) => {
                    p.product_qty = 0;
                    products.push(p);
                });
                this.setState({ products: products });
                let store_contract = this.state.store_contract;
                this.state.products.forEach((product, index) => {
                    let value = product.product_qty;
                    let returned_count = 0;
                    let currSch = null
                    if (s) {
                        let schedule_date = moment.isMoment(this.state.new_delivery.schedule_date) ? this.state.new_delivery.schedule_date.format(format) : this.state.new_delivery.schedule_date;
                        currSch = s.filter((schedule) => schedule.product_id === product.id && schedule.schedule_date === schedule_date);
                        if (currSch.length === 1) {
                            value = this.state.approvalRequired ? (toInt(currSch[0].revised_delivered_count) === 0 ? toInt(currSch[0].delivered_count) : toInt(currSch[0].revised_delivered_count)) : ((!this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date ? true : false) ? currSch[0].delivered_count : toInt(currSch[0].product_qty));
                            returned_count = toInt(currSch[0].revised_returned_count) === 0 ? toInt(currSch[0].returned_count) : toInt(currSch[0].revised_returned_count);
                            returnMap.set(currSch[0].product_id, returned_count);
                            if (!(!this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date)) {
                                prodMap.set(currSch[0].product_id, value);
                            }
                        }
                    }
                    if ((currSch && currSch.length === 1) || store_contract.has(product.id)) {
                        pr.push(
                            <tr key={index}>
                                <td style={{ verticalAlign: "middle" }}>{product.name}</td>
                                <td style={{ verticalAlign: "middle" }}>
                                    <TextField
                                        label={this.state.approvalRequired ? "Delivered Count" : "Qty"}
                                        placeholder={this.state.approvalRequired ? "Delivered Count" : "Qty"}
                                        name={product.id}
                                        defaultValue={value}
                                        className={this.props.classes.textField}
                                        margin="normal"
                                        variant="outlined"
                                        onChange={this.handleChange}
                                        disabled={!this.state.periodic && !this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date ? true : false}
                                        helperText={!this.state.periodic && !this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date ? `Already Delivered @ ${getTimeInIST(currSch[0].delivery_date).format(format_fancy)}` : ''}
                                        error={!this.state.periodic && !this.state.approvalRequired && currSch && currSch.length === 1 && currSch[0].delivery_date ? true : false}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">Nos</InputAdornment>,
                                            inputProps: { min: 0, step: 1 }
                                        }} />
                                </td>
                                {   false &&
                                    this.state.approvalRequired &&
                                    <td style={{ verticalAlign: "middle" }}>
                                        <TextField
                                            label="Returned Count"
                                            placeholder="Returned Count"
                                            name={product.id}
                                            defaultValue={returned_count}
                                            className={this.props.classes.textField}
                                            margin="normal"
                                            variant="outlined"
                                            onChange={this.handleChangeReturn}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">Nos</InputAdornment>,
                                                inputProps: { min: 0, step: 1 }
                                            }} />
                                    </td>
                                }
                            </tr>
                        );
                    }
                });
                /* disabled={currSch && currSch.length === 1 && currSch[0].delivery_date} */
                if (customer_id) {
                    nd.products = prodMap;
                    nd.returns = returnMap;
                    this.setState({ new_delivery: nd });
                }
                this.setState({ product_rows: pr });
                // this.setState({product_rows: pr});
            })
            .catch(error => console.log(error));
    }

    showDetails(e, user, schedule_date) {
        let deliveries = [];
        this.state.customerDeliveryMap.get(user.transaction_id).forEach((element, index) => {
            // if(user.invoice_no === element.invoice_no){
            deliveries.push(<ProductDeliveryDetails key={element.id + index} delivery={element} />);
            // }
        });
        this.setState({ modal: { customer: user, deliveries: deliveries }, show_approval_option: user.approval_pending === '1' ? true : false });
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false, show_approval_option: false, loading: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleCloseNew() {
        this.setState({ showNewDelivery: false, editMode: false, approvalRequired: false, periodic: false, schedule_date_end: undefined });
        this.resetNewDelivery();
    }

    handleShowNew(isNew = false, periodic = false) {
        let route_id = this.state.customerList.filter(s => s.id === this.state.selected_customer)[0].route_name;
        let po_no = this.state.customerList.filter(s => s.id === this.state.selected_customer)[0].po_no;
        this.setState(prevState => ({
            showNewDelivery: true,
            periodic: periodic,
            schedule_date_end: moment(),
            new_delivery: isNew ? { customer_id: this.state.selected_customer, transaction_id: undefined, po_no: po_no, route_id: route_id, schedule_date: this.state.new_delivery.schedule_date ? this.state.new_delivery.schedule_date : moment().startOf('day') } : prevState.new_delivery
        }), () => this.fetchProductRows(this.state.selected_customer, this.state.new_delivery.invoice_no, this.state.new_delivery.transaction_id));
    }

    handleDeliveryDateChange(date) {
        let nd = this.state.new_delivery;
        nd.schedule_date = date;
        this.setState({ new_delivery: nd }, () => {
            this.fetchTotalCount(() => {
                this.fetchData(0, this.state.numItemsPerPage, true, true);
            });
        });
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.new_delivery;
        let products = change.products;
        products.set(e.target.name, e.target.value);
        change.products = products;
        this.setState({ new_delivery: change });
    }

    handleChangePO = (e) => {
        e.preventDefault();
        let change = this.state.new_delivery;
        change[e.target.name] = e.target.value;
        this.setState({ new_delivery: change });
    }

    handleChangeReturn = (e) => {
        e.preventDefault();
        let change = this.state.new_delivery;
        let returns = change.returns;
        returns.set(e.target.name, e.target.value);
        change.returns = returns;
        this.setState({ new_delivery: change });
    }

    confirmScheduleNewDelivery = () => {

        let rows = [];

        let nd = this.state.new_delivery;
        let { new_delivery_orginal, approvalRequired } = this.state;
        let proceed = false;
        let message = 'No changes made';
        if (approvalRequired && new_delivery_orginal) {
            nd.products.forEach((value, key) => {
                let returnValue = toInt(nd.returns.has(key) ? nd.returns.get(key) : 0);
                // if(toInt(value) > 0 || returnValue > 0){
                let s = new_delivery_orginal.schedules.filter(s => s.product_id === key && s.schedule_date === nd.schedule_date);
                if (s.length === 1) {
                    let valueTocompare = s[0].approval_pending === '1' ? toInt(s[0].revised_delivered_count) : toInt(s[0].delivered_count);
                    let valueTocompareReturns = s[0].approval_pending === '1' ? toInt(s[0].revised_returned_count) : toInt(s[0].returned_count);
                    if ((valueTocompare !== toInt(value) || valueTocompareReturns !== returnValue)) {
                        // if((valueTocompare !== toInt(value) || valueTocompareReturns !== toInt(nd.returns.get(key)))){
                        proceed = true;
                    }
                } else if (s.length === 0) {
                    proceed = true;
                }
                // }
            });
            if (!proceed) {
                nd.returns.forEach((value, key) => {
                    let s = new_delivery_orginal.schedules.filter(s => s.product_id === key && s.schedule_date === nd.schedule_date);
                    if (s.length === 1) {
                        let valueTocompareReturns = s[0].approval_pending === '1' ? toInt(s[0].revised_returned_count) : toInt(s[0].returned_count);
                        if (valueTocompareReturns !== toInt(value)) {
                            proceed = true;
                        }
                    } else if (s.length === 0) {
                        proceed = true;
                    }
                });
            }
        } else {
            if (nd.customer_id) {
                nd.products.forEach((value, key) => {
                    if (toInt(value) > 0) {
                        proceed = true;
                    }
                });
                message = 'Select Products and proceed';
            } else {
                message = 'Select Store and proceed';
            }
        }

        if (proceed) {
            let message = (
                <Typography component="span">
                    Confirm {this.state.approvalRequired ? 'Schedule Changes' : 'Schedule'} for store, Date
                    <span style={{ color: 'black', fontWeight: 'bolder' }}> {moment(this.state.new_delivery.schedule_date).format(format_fancy_notime)}</span>
                    ?
                </Typography>
            );

            if (this.state.periodic) {
                message = (
                    <Typography component="span">
                        Confirm Periodic Schedule for store, from
                        <span style={{ color: 'black', fontWeight: 'bolder' }}> {moment(this.state.new_delivery.schedule_date).format(format_fancy_notime)} </span>
                        to<span style={{ color: 'black', fontWeight: 'bolder' }}> {moment(this.state.schedule_date_end).format(format_fancy_notime)}</span>
                        ?
                    </Typography>
                );
                this.props.showConfirmDialog(message, undefined, () => {
                    this.props.closeConfirmDialog();
                    this.setState({ loading: true });

                    DeliveryService.getScheduleStatusForStore(nd.customer_id, nd.schedule_date, this.state.schedule_date_end)
                        .then(data => {
                            let datesWithSchedule = data.status.filter(s => s.count > 0).map(s => s.schedule_date);

                            if (datesWithSchedule.length > 0) {
                                this.props.showConfirmDialog3Option(message, undefined, "Schedule for All days", () => {
                                    this.props.closeConfirmDialog3Option();
                                    this.scheduleMultiple(nd);
                                }, "Ignore already scheduled and proceed", () => {
                                    this.props.closeConfirmDialog3Option();
                                    this.scheduleMultiple(nd, true, datesWithSchedule);
                                });
                            } else {
                                this.scheduleMultiple(nd);
                            }

                            this.setState({ loading: false });
                        })
                        .catch(error => {
                            console.log(error);
                            this.setState({ loading: false });
                        });

                });

            } else {
                this.props.showConfirmDialog(message, undefined, () => {
                    this.props.closeConfirmDialog();
                    this.setState({ loading: true });
                    nd.products.forEach((value, key, map) => {
                        let p = this.state.products.filter((p) => p.id === key)[0];
                        let total_amount = toInt(value) * parseFloat(p.unit_price, 10);
                        // let po_no = this.state.customerList.filter((store) => store.id === nd.customer_id)[0].po_no;
                        rows.push({
                            id: nd.id,
                            transaction_id: nd.transaction_id,
                            user_id: nd.customer_id,
                            product_id: key,
                            schedule_date: moment(nd.schedule_date).format(format_without_time),
                            product_qty: toInt(value),
                            returned_count: toInt(nd.returns.has(key) ? nd.returns.get(key) : 0),
                            total_amount: total_amount,
                            po_no: nd.po_no,
                            invoice_no: nd.invoice_no,
                            delivery_agent_id: nd.delivery_agent_id,
                            delivery_date: nd.delivery_date ? nd.delivery_date.format(format) : nd.delivery_date,
                            geo_location: nd.geo_location,
                            route_id: nd.route_id
                            // signature : nd.signature
                        });
                    });

                    if (nd.delivery_date) {
                        nd.returns.forEach((value, key, map) => {
                            if (!nd.products.has(key)) {
                                let total_amount = 0;
                                // let po_no = this.state.customerList.filter((store) => store.id === nd.customer_id)[0].po_no;
                                rows.push({
                                    id: nd.id,
                                    transaction_id: nd.transaction_id,
                                    user_id: nd.customer_id,
                                    product_id: key,
                                    schedule_date: moment(nd.schedule_date).format(format_without_time),
                                    product_qty: 0,
                                    returned_count: toInt(value),
                                    total_amount: total_amount,
                                    po_no: nd.po_no,
                                    invoice_no: nd.invoice_no,
                                    delivery_agent_id: nd.delivery_agent_id,
                                    delivery_date: nd.delivery_date ? nd.delivery_date.format(format) : nd.delivery_date,
                                    geo_location: nd.geo_location,
                                    route_id: nd.route_id
                                    // signature : nd.signature
                                });
                            }
                        });
                    }

                    let body = { rows: rows, approval_pending: approvalRequired ? 1 : 0, src: 'Web' };
                    DeliveryService.createDelivery(body, { 'user-id': this.props.user.id, 'user-name': this.props.user.name })
                        .then((data) => {
                            if (data.multiple_deliveries > 0 && data.success === 0) {
                                this.props.showConfirmDialog(`Cannot schedule more than 1 Delivery per day for this store`, undefined, undefined)
                            } else if (data.already_delivered > 0 && data.success === 0) {
                                this.props.showConfirmDialog(`Delivery is already completed for this store. Please refresh the page to check status.`, undefined, undefined)
                            } else {
                                console.log(data);
                                this.resetNewDelivery();
                                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                                let today = moment(nd.schedule_date).startOf('day').isSame(moment().startOf('day'));
                                if (!nd.delivery_date && today) {
                                    NotificationService.notifyAgentsAboutDeliveryChanges(nd.route_id, nd.schedule_date, this.state.customer_names.filter(s => s.id === nd.customer_id)[0].label);
                                }
                                this.handleCloseNew();
                            }
                            this.setState({ loading: false });
                        })
                        .catch((error) => {
                            console.log(error);
                            this.setState({ loading: false });
                        });
                });
            }
        } else {
            this.props.showSnackBar(message, 'warning')
        }
    }

    scheduleMultiple = (nd, ignore = false, datesWithSchedule = []) => {
        this.setState({ loading: true });
        let rowsList = [];
        let startdate = moment(nd.schedule_date);
        while (startdate.isSameOrBefore(this.state.schedule_date_end)) {
            let rows = [];
            if (!(ignore && datesWithSchedule.includes(startdate.format(format)))) {
                nd.products.forEach((value, key, map) => {
                    let p = this.state.products.filter((p) => p.id === key)[0];
                    let total_amount = toInt(value) * parseFloat(p.unit_price, 10);
                    // let po_no = this.state.customerList.filter((store) => store.id === nd.customer_id)[0].po_no;
                    rows.push({
                        id: nd.id,
                        transaction_id: nd.transaction_id,
                        user_id: nd.customer_id,
                        product_id: key,
                        schedule_date: startdate.format(format_without_time),
                        product_qty: toInt(value),
                        returned_count: toInt(nd.returns.has(key) ? nd.returns.get(key) : 0),
                        total_amount: total_amount,
                        po_no: nd.po_no,
                        invoice_no: nd.invoice_no,
                        delivery_agent_id: nd.delivery_agent_id,
                        delivery_date: nd.delivery_date ? nd.delivery_date.format(format) : nd.delivery_date,
                        geo_location: nd.geo_location,
                        route_id: nd.route_id
                        // signature : nd.signature
                    });
                });
                rowsList.push(rows);
            }
            startdate.add(1, "day").startOf('day');
        }

        console.log(rowsList);

        let requestList = rowsList.map(rows => {
            let body = { rows: rows, approval_pending: 0 };
            return DeliveryService.createDelivery(body, { 'user-id': this.props.user.id, 'user-name': this.props.user.name });
        });

        Promise.all(requestList)
            .then(data => {
                console.log(data);
                let already_delivered = 0;
                let success = 0;
                data.forEach(response => {
                    if (response.already_delivered > 0 && response.success === 0) {
                        already_delivered++;
                    } else if (response.error === 0) {
                        success++;
                    }
                });
                let message = already_delivered > 0 ? `Already Delivered for ${already_delivered} ${already_delivered === 1 ? `day` : `days`}. ` : '';
                message = `${message}${(success === 0 ? `No Schedules added` : `Added schedules for ${success} ${success < 2 ? `day` : `days`}.`)}`;
                this.props.showConfirmDialog(message, undefined, undefined);
                this.resetNewDelivery();
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                this.handleCloseNew();
                this.setState({ loading: false });
            })
            .catch(error => {
                this.setState({ loading: false });
                console.log(error);
            });
    }

    scheduleNewDelivery(e) {
        if (e) {
            e.preventDefault();
        }

    }

    resetNewDelivery() {
        this.setState({ new_delivery: { schedule_date: moment().startOf('day'), products: new Map(), returns: new Map(), delivery_date: undefined } });
    }

    updateDeliveryDetails(customer_id, invoice_no, transaction_id) {
        this.fetchProductRows(customer_id, invoice_no, transaction_id);
    }

    resendCreditNote = (e, user) => {
        if (e) {
            e.preventDefault();
        }
        if (user.returned_count > 0) {
            this.props.showConfirmDialog(`Confirm re-send Credit note for ${user.store_name}?`, undefined, () => {
                let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, invoice_no: user.invoice_no };
                this.props.showProgressDialog("Resending Credit Note...");
                DeliveryService.resendCreditNote(body, Constants.STORE)
                    .then((data) => {
                        console.log(data);
                        this.props.closeConfirmDialog();
                        if (data.success) {
                            this.props.showSnackBar('Credit note sent successfully', 'success');
                        } else {
                            this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                        }
                        this.props.closeProgressDialog();
                    })
                    .catch(() => {
                        this.props.closeConfirmDialog();
                        this.props.closeProgressDialog();
                        console.log("Error Occurred while resending Credit Note");
                        this.props.showSnackBar('Something went wrong. Please try again later or contact the admin', 'error');
                    });
            });
        }
    }

    resendInvoice(e, user, msg) {
        if (e) {
            e.preventDefault();
        }
        if (user.invoice_no) {
            this.props.showConfirmDialog(msg ? msg : `Confirm re-send invoice for ${user.store_name}?`, undefined, () => {
                let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, invoice_no: user.invoice_no };
                this.props.showProgressDialog("Resending Invoice...");
                DeliveryService.resendInvoice(body, Constants.STORE)
                    .then((data) => {
                        console.log(data);
                        this.props.closeConfirmDialog();
                        if (data.success) {
                            this.props.showSnackBar('Invoice sent successfully', 'success');
                        } else {
                            this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                        }
                        this.props.closeProgressDialog();
                    })
                    .catch(() => {
                        this.props.closeConfirmDialog();
                        this.props.closeProgressDialog();
                        console.log("Error Occurred while resending Invoice");
                        this.props.showSnackBar('Something went wrong. Please try again later or contact the admin', 'error');
                    });

                if (msg) {
                    if (user.returned_count > 0) {
                        let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, invoice_no: user.invoice_no };
                        DeliveryService.resendCreditNote(body, Constants.STORE)
                            .then((data) => {
                                console.log(data);
                                this.props.closeConfirmDialog();
                                if (data.success) {
                                    this.props.showSnackBar('Credit note sent successfully', 'success');
                                } else {
                                    this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                                }
                            })
                            .catch(() => {
                                this.props.closeConfirmDialog();
                                console.log("Error Occurred while resending Credit Note");
                                this.props.showSnackBar('Something went wrong. Please try again later or contact the admin', 'error');
                            });
                    }
                }
            });
        }
    }

    markDelivery = (user) => {
        console.log(user);
        this.setState({ delivery_dialog_user: user, dialog_open: true });
    }

    edit(e, user, approvalRequired = false) {
        e.preventDefault();
        let nd = this.state.new_delivery;
        nd.customer_id = user.id;
        nd.transaction_id = user.transaction_id;
        nd.delivery_date = moment(user.delivery_date)
        nd.route_id = user.route_id;
        nd.store_name = user.store_name;
        nd.schedule_date = user.schedule_date;
        nd.invoice_no = user.invoice_no && user.invoice_no.length > 0 ? user.invoice_no : undefined;
        if (approvalRequired) {
            nd.delivery_agent_id = user.delivery_agent_id;
            nd.geo_location = user.geo_location;
            // nd.signature = user.signature;
        }
        this.setState({
            new_delivery: nd,
            editMode: true,
            approvalRequired: approvalRequired,
            new_delivery_orginal: approvalRequired ? Object.assign({}, nd) : undefined
        }, () => this.handleShowNew(false));
    }

    delete(e, user) {
        e.preventDefault();
        this.props.showConfirmDialog(`Delete Delivery Schedule for ${user.name}?`, undefined, () => {
            this.props.isLoading(true);
            let body = { user_id: user.id, schedule_date: user.schedule_date, route_id: user.route_id, transaction_id: user.transaction_id };
            DeliveryService.removeDelivery(body, { 'user-id': this.props.user.id, 'user-name': this.props.user.name })
                .then((data) => {
                    console.log(data);
                    this.props.closeConfirmDialog();
                    if (data.success) {
                        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                    } else {
                        this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                    }
                    // this.hide();
                    this.props.isLoading(false);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }

    postUpdate() {
        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, false, false);
    }

    handleApprove = () => {
        console.log(this.state.modal.customer);
        if (this.state.modal.customer && this.state.modal.deliveries.length > 0) {
            this.props.showConfirmDialog(`Confirm Approval for Store ${this.state.modal.customer.name}?`, undefined, () => {
                this.setState({ loading: true });
                this.props.closeConfirmDialog();
                handleApproveDeliveryChange(this.state.modal.customer.transaction_id, this.props.user.id, { 'user-id': this.props.user.id, 'user-name': this.props.user.name }, (data) => {
                    console.log(data);
                    if (data.success) {
                        this.handleClose();
                        this.props.showSnackBar('Approved', 'success');
                        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, false, false);
                    } else {
                        this.props.showSnackBar('Something went wrong. Please try again later', 'error');
                    }
                    this.setState({ loading: false });
                }, (error) => {
                    console.log(error);
                    this.setState({ loading: false });
                })
            });
        }
    }

    render() {
        let classes = this.props.classes;
        let customer = this.state.customer;
        let { dialog_open, delivery_dialog_user } = this.state;
        let session_user = this.props.user;
        return (
            <div className="Home">
                <div style={{ marginTop: 32 }}>
                    <Grid container spacing={8}>
                        <Grid item lg={6} xs={12}>
                            <Grid container spacing={0} item lg={12} xs={12}>
                                <Grid item lg={8} xs={12}>
                                    <FormControl variant="outlined" className={clsx(classes.formControl, classes.autoCompleteSelection)}>
                                        <Autocomplete
                                            id="store-selection"
                                            disableClearable
                                            size="small"
                                            options={this.state.customer_names}
                                            getOptionLabel={option => (option && option.label) || ''}
                                            value={this.state.selectedCustomerBasic || null}
                                            required={true}
                                            onChange={this.handleCustomerSelection}
                                            className={classes.autoCompleteSelectionTextField}
                                            style={{ zIndex: 2 }}
                                            renderInput={params => (
                                                <TextField {...params} label="Select Customer" variant="outlined" fullWidth />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                                <Hidden mdDown><Grid item lg={2} xs={12}></Grid></Hidden>
                                <Grid item lg={4} xs={12} sm={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="inline"
                                            inputVariant="outlined"
                                            margin="normal"
                                            label="From"
                                            size="small"
                                            value={this.state.startDate}
                                            onChange={this.handleChangeStartDate}
                                            format='DD MMM YYYY'
                                            maxDate={this.state.endDate}
                                            className={classes.formControl}
                                            InputLabelProps={{
                                                style: { zIndex: 'auto' }
                                            }}
                                            style={{ height: "100%", marginTop: 8 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item lg={4} xs={12} sm={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            variant="inline"
                                            inputVariant="outlined"
                                            margin="normal"
                                            label="To"
                                            size="small"
                                            value={this.state.endDate}
                                            onChange={this.handleChangeEndDate}
                                            format='DD MMM YYYY'
                                            minDate={this.state.startDate}
                                            className={classes.formControl}
                                            InputLabelProps={{
                                                style: { zIndex: 'auto' }
                                            }}
                                            style={{ height: "100%", marginTop: 8 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs="auto" sm={12}>

                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {customer &&
                                <Card className={classes.card} style={customer.status === '2' ? { backgroundColor: Color.yellow } : customer.status === '0' ? { backgroundColor: Color.red } : {}}>
                                    <CardContent>
                                        <Grid container alignItems="center" justify="space-between" spacing={2}>
                                            <Grid item xs={2} lg={2}>
                                                <Typography variant="subtitle2" align="left">
                                                    <b>Address</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9} lg={9}>
                                                <Typography variant="body2" align="left">
                                                    {customer.flat}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1} lg={1}>
                                                {
                                                    customer.location && (
                                                        <Tooltip arrow title="View location on Map">
                                                            <Glyphicon glyph="map-marker" onClick={(e) => openMap(customer.location)} style={{ marginLeft: 8 }} />
                                                        </Tooltip>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={2} lg={2}>
                                                <Typography variant="subtitle2" align="left">
                                                    <b>Mobile</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={10} lg={10}>
                                                <Typography variant="body2" align="left">
                                                    {customer.mobile_no}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2} lg={2}>
                                                <Typography variant="subtitle2" align="left">
                                                    <b>Email</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={10} lg={10}>
                                                <Typography variant="body2" align="left">
                                                    {customer.email || "-"}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2} lg={2}>
                                                <Typography variant="subtitle2" align="left">
                                                    <b>Route</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={4} lg={4}>
                                                <Typography variant="body2" align="left">
                                                    {customer.route_name || '-'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={3} lg={3}>
                                                <Typography variant="subtitle2" align="left">
                                                    <b>Balance Credit</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={3} lg={3}>
                                                <Typography variant="body2" align="left" color={customer.user_balance <= 0 ? "secondary" : "primary"}>
                                                    {customer.user_balance}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        {/* { customer &&
                                        <Typography color="textSecondary" align="left" variant="body1">
                                            {customer.status === "0" && <li>Store is deactivated.</li>}
                                            {customer.status === "2" && <li>Store is paused.</li>}
                                            {customer.status === "2" && <li>Reason: {customer.pause_reason}</li>}
                                            {customer.status === "2" && <li>Paused on: {getTimeInIST(customer.pause_datetime).format(format_fancy)}</li>}
                                            {customer.generate_invoice === "0" && <li>Generation of invoices and credit notes are disabled.</li>}
                                            {store_contract.size === 0 && <li>No contracts have been defined for store</li>}
                                            {!this.state.customerList.filter(s => s.id === this.state.selected_customer)[0].route_name && <li>Store is not mapped to any route.</li>}
                                        </Typography>
                                    } */}
                                    </CardContent>
                                </Card>
                            }
                        </Grid>
                    </Grid>
                </div>
                <div>
                    <Paper className={this.props.classes.root} style={{ width: "100%", marginTop: 15, paddingLeft: 5, paddingRight: 5, marginBottom: 70 }}>
                        <Table striped condensed hover responsive>
                            <EnhancedTableHead
                                order={'asc'}
                                orderBy={'name'}
                                onRequestSort={() => { }}
                                rows={this.state.columns} />
                            <TableBody>
                                {this.state.current_rows.length > 0 ?
                                    this.state.current_rows : this.state.show_skeleton_selection &&
                                    this.state.skeleton_rows_table
                                }
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={RowCountOptions}
                            component="div"
                            count={this.state.totalItems}
                            rowsPerPage={this.state.numItemsPerPage}
                            page={this.state.currentPageNumber}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            classes={{ selectRoot: classes.selectRoot }}
                        />
                    </Paper>
                </div>
                <DialogMUI
                    open={this.state.show}
                    onClose={this.handleClose}
                    fullWidth={true}
                    maxWidth={'lg'}
                    style={{ paperWidthSm: '17' }}
                    aria-labelledby="responsive-dialog-title"
                    scroll='paper'>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                    <DialogTitle id="alert-dialog-title">{`Delivery Details - ${this.state.modal.customer.name}`}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <Divider />
                            <Table striped condensed hover responsive>
                                <thead>
                                    <tr>
                                        <th>Product Name</th>
                                        <th>Scheduled Qty</th>
                                        <th>Total Amount</th>
                                        <th>Delivered Count</th>
                                        <th>Bottles Returned Count</th>
                                        <th>Delivery Date</th>
                                    </tr>
                                </thead>
                                <tbody style={{ textAlign: "left" }}>
                                    {this.state.modal.deliveries}
                                </tbody>
                            </Table>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {this.state.show_approval_option &&
                            <Button onClick={this.handleApprove} color="secondary" autoFocus disabled={this.state.loading}>
                                Approve
                            </Button>
                        }
                        <Button onClick={this.handleClose} color="primary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                </DialogMUI>
                {/* Schedule Future Deliveries for Stores */}
                <DialogMUI
                    fullWidth={true}
                    maxWidth="md"
                    disableBackdropClick
                    disableEscapeKeyDown
                    open={this.state.showNewDelivery}
                    onClose={this.handleCloseNew}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                    <DialogTitle id="alert-dialog-title">
                        Delivery Details
                        {this.state.approvalRequired &&
                            <Typography variant="button" id="modal-title" color="secondary">
                                <br />
                                [NOTE] This change Requires Approval as the delivery has already been taken place
                            </Typography>
                        }
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" component={'span'}>
                            <FormGroup>
                                <ControlLabel>Customer<sup>*</sup></ControlLabel>
                                <Typeahead
                                    id="typeahead-id-view-store-delivery"
                                    onChange={(selected) => {
                                        let nd = this.state.new_delivery;
                                        if (selected.length > 0) {
                                            nd.customer_id = selected[0].id;
                                            nd.name = selected[0].name
                                            nd.route_id = selected[0].route_name;
                                            this.setState({ new_delivery: nd });
                                            if (this.state.customerDeliveryMap.has(nd.transaction_id)) {
                                                this.updateDeliveryDetails(nd.customer_id, nd.invoice_no, nd.transaction_id);
                                            }
                                        } else {
                                            this.setState({ new_delivery: { schedule_date: moment(), products: new Map(), returns: new Map(), delivery_date: undefined } });
                                            this.fetchProductRows(null, undefined);
                                        }
                                    }}
                                    options={this.state.customerList.filter((store) => store.id === this.state.selected_customer
                                        //&& !this.state.customerDeliveryMap.has(store.id)
                                    )}
                                    labelKey={option => `${option.name} [Address: ${option.flat}]`}
                                    filterBy={['store_name', 'flat']}
                                    placeholder="Store"
                                    size="small"
                                    disabled
                                    selected={this.state.customerList.filter((store) => store.id === this.state.selected_customer)}
                                    defaultSelected={
                                        this.state.customerList.filter((store) => store.id === this.state.new_delivery.customer_id)
                                    } />
                            </FormGroup>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <DatePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    disabled={this.state.editMode}
                                    margin="normal"
                                    size="small"
                                    label="Delivery Date"
                                    value={this.state.new_delivery.schedule_date}
                                    onChange={this.handleDeliveryDateChange}
                                    format='DD/MM/YYYY'
                                    minDate={this.state.approvalRequired ? undefined : moment()}
                                    style={{ height: "100%", marginRight: "20px" }}
                                />
                            </MuiPickersUtilsProvider>
                            {
                                this.state.periodic &&
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <DatePicker
                                        variant="inline"
                                        inputVariant="outlined"
                                        margin="normal"
                                        size="small"
                                        label="Periodic End Date"
                                        value={this.state.schedule_date_end}
                                        onChange={(date) => this.setState({ schedule_date_end: date })}
                                        format='DD/MM/YYYY'
                                        minDate={this.state.new_delivery.schedule_date}
                                        style={{ height: "100%", marginRight: "20px" }} />
                                </MuiPickersUtilsProvider>
                            }
                            <Typography variant="subtitle1" id="modal-title">
                                Products
                            </Typography>
                            <Divider variant='middle' />
                            <Table>
                                <tbody>
                                    {this.state.product_rows.length > 0 ?
                                        this.state.product_rows :
                                        this.state.skeleton_rows
                                    }
                                </tbody>
                            </Table>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseNew} color="primary">
                            Close
                        </Button>
                        <Button onClick={this.confirmScheduleNewDelivery} color="primary" autoFocus disabled={this.state.loading}>
                            {
                                this.state.approvalRequired ? 'Schedule Changes' : 'Schedule'
                            }
                        </Button>
                    </DialogActions>
                    {this.state.loading &&
                        <LinearProgress color="secondary" style={{ height: 30 }} />
                    }
                </DialogMUI>
                {false &&
                {/* <Fab onClick={(e) => this.handleShowNew(true)} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '90%'}}>
                        <AddIcon />
                    </Fab> */}
                }
                {(session_user.roles.includes(ROLES.ADMIN)) && this.state.selected_customer !== '-1' && customer.status === '1' && this.state.store_contract.size > 0 && this.state.customerList.filter(s => s.id === this.state.selected_customer)[0].route_name &&

                    <SpeedDial
                        ariaLabel="SpeedDial Add Schedule"
                        className={classes.speedDial}
                        icon={<SpeedDialIcon />}
                        onClose={this.handleCloseSpeedDial}
                        onOpen={this.handleOpenSpeedDial}
                        open={this.state.speedDialOpen}
                        direction={this.state.speedDialDirection}
                    >
                        <SpeedDialAction
                            key={"Single"}
                            icon={<TodayIcon />}
                            tooltipTitle={"Add Single Schedule"}
                            TooltipClasses={{ tooltip: classes.tooltiptitle }}
                            onClick={(e) => this.handleShowNew(true)}
                        />
                        <SpeedDialAction
                            key={"Periodic"}
                            icon={<DateRangeIcon />}
                            tooltipTitle={"Add Periodic Schedule"}
                            TooltipClasses={{ tooltip: classes.tooltiptitle }}
                            onClick={(e) => this.handleShowNew(true, true)}
                        />
                    </SpeedDial>
                }
                <MarkCustomerDelivery customer={delivery_dialog_user} open={dialog_open}
                    close={() => {
                        this.setState({ dialog_open: false, delivery_dialog_user: undefined });
                    }}
                    save={() => {
                        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                    }}
                    {...this.props}
                />
            </div>
        );
    }
}

class DeliveryDetails extends Component {

    render() {
        const user = this.props.user;
        let away = parseFloat(user.away);
        let session_user = this.props.session_user;
        let isMarkedNotDeliverable = (user.delivered_count === 0 && user.delivery_date && user.delivery_agent_id ? true : false);

        return (
            <tr className={!user.delivery_date && moment(user.schedule_date).utc().isBefore(moment().startOf('day')) ? "danger" : user.approval_pending === '1' ? 'approval_pending' : ''} >
                <td>{user.schedule_date ? getTimeInIST(user.schedule_date).format(format_display_DDMMYYYY) : "-"}</td>
                <td>{user.delivery_date ? (away >= 0 ?
                    <Tooltip title={`Marked at a distance of ${convertDistance(away)} from store`}>
                        <Chip size="small" label={convertDistance(away)} color={away > 50 ? "secondary" : "primary"} variant={away > 50 ? "default" : "outlined"} />
                    </Tooltip>
                    : <Chip size="small" label={away === -1 ? "Failed to Obtain location" : "Not available"} variant="outlined" color="secondary" />) : '-'}
                </td>
                <td>{user.product_qty}</td>
                <td>{formatNumber(Math.round(user.total_amount))}</td>
                <td>{(user.approval_pending === '1' && (user.delivered_count !== 0 || user.revised_delivered_count !== 0) && user.delivered_count !== user.revised_delivered_count) ? (<span><strike style={{ color: 'red' }}>{user.delivered_count}</strike><br /> {user.revised_delivered_count}</span>) : user.delivered_count}</td>
                <td>{user.bottles_returned || 0}</td>
                {/* <td>{user.replaced_count}</td> */}
                <td>{user.delivery_date ? <ListItemText style={isMarkedNotDeliverable ? { color: "#b71c1c" } : {}} primaryTypographyProps={{variant: 'body2'}} primary={getTimeInIST(user.delivery_date).format(format_fancy)} secondary={isMarkedNotDeliverable ? user.reason : ""} /> : "-"}</td>
                <td style={{ textAlign: "right" }}>
                    <HtmlTooltip arrow title={"Schedule details"}>
                        <Glyphicon glyph="list-alt" onClick={(e) => this.props.showDetails(e, user, user.schedule_date)} />
                    </HtmlTooltip>
                    {(session_user.roles.includes(ROLES.ACCOUNTS_ADMIN) || session_user.roles.includes(ROLES.ADMIN)) && user.approval_pending === '1' ?
                        <HtmlTooltip arrow title={"Approve the Changes"} >
                            <Glyphicon glyph="ok" onClick={(e) => this.props.showDetails(e, user, user.schedule_date)} style={{ marginLeft: "10px" }} />
                        </HtmlTooltip>
                        :
                        ''
                    }
                    {
                        (session_user.roles.includes(ROLES.ADMIN))
                        && (user.delivery_date || moment(user.schedule_date).utc().isBefore(moment().startOf('day')) ? "" : <Glyphicon glyph="trash" style={{ marginLeft: "10px" }} onClick={(e) => this.props.delete(e, user)} />)
                    }
                    {
                        (session_user.roles.includes(ROLES.ADMIN)) && (
                            user.delivery_date && !isMarkedNotDeliverable ?
                                <HtmlTooltip arrow title={"Edit Delivery (Requires Admin Approval)"}>
                                    <Glyphicon glyph="pencil" style={{ marginLeft: "10px" }} onClick={(e) => this.props.edit(e, user, true)} />
                                </HtmlTooltip>
                                :
                                (getTimeInIST(user.schedule_date).utc().isBefore(moment().startOf('day')) ? "" :
                                    <HtmlTooltip arrow title={"Edit Delivery"}>
                                        <Glyphicon glyph="pencil" style={{ marginLeft: "10px" }} onClick={(e) => this.props.edit(e, user, false)} />
                                    </HtmlTooltip>)
                        )
                    }
                    {
                        (session_user.roles.includes(ROLES.ADMIN)) && (
                            user.delivery_date ?
                                ''
                                :
                                (getTimeInIST(user.schedule_date).isBefore(moment().startOf('day')) ? "" :
                                    <HtmlTooltip arrow title={"Mark Delivery"}>
                                        <Icon style={{ marginLeft: "10px" }} onClick={(e) => this.props.markDelivery(user)}>local_shipping</Icon>
                                    </HtmlTooltip>)
                        )
                    }
                </td>
            </tr>
        );
    }
}

class ProductDeliveryDetails extends Component {

    render() {
        const delivery = this.props.delivery;

        return (
            <tr>
                <td>{delivery.product_name}</td>
                <td align="center">{delivery.product_qty}</td>
                <td align="center">{formatNumber(delivery.total_amount)}</td>
                <td align="center">{delivery.approval_pending === '1' && (delivery.delivered_count !== 0 || toInt(delivery.revised_delivered_count) !== 0) && delivery.delivered_count !== delivery.revised_delivered_count ? (<span><strike style={{ color: 'red' }}>{delivery.delivered_count}</strike><br /> {delivery.revised_delivered_count}</span>) : delivery.delivered_count}</td>
                <td align="center">{delivery.bottles_returned}</td>
                <td align="left">{delivery.delivery_date ? getTimeInIST(delivery.delivery_date).format(format_fancy) : "-"}</td>
            </tr>
        );
    }
}

export default withStyles(styles)(ViewCustomerSchedule);